"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.connections = void 0;
const integroApiSchema = __importStar(require("./integro-api.json"));
const metersSchema = __importStar(require("./meters.json"));
const meterStatsSchema = __importStar(require("./meter-stats.json"));
const wasteBinsSchema = __importStar(require("./waste-bins.json"));
exports.connections = [
    {
        name: 'integro_api',
        kind: 'openapi',
        url: '<%= integro_api_openapi_json_url %>',
        baseUrl: '<%= integro_api_base_url %>',
        schema: integroApiSchema
    },
    {
        name: 'meters',
        kind: 'openapi',
        url: '<%= meters_api_openapi_json_url %>',
        baseUrl: '<%= meters_api_base_url %>',
        schema: metersSchema
    },
    {
        name: 'meter_stats',
        kind: 'openapi',
        url: '<%= meter_stats_api_openapi_json_url %>',
        baseUrl: '<%= meter_stats_api_base_url %>',
        schema: meterStatsSchema
    },
    {
        name: 'waste_bins',
        kind: 'openapi',
        url: '<%= waste_bins_api_openapi_json_url %>',
        baseUrl: '<%= waste_bins_api_base_url %>',
        schema: wasteBinsSchema
    }
];
